import ssrs from './ssrs.js';
import {initSsrsViewer} from './ssrsReportViewer.js';

export default function () {
  if ($('#reportViewer').length) {
    ssrs();
  }
  if ($('#frmReportViewer').length) {
    initSsrsViewer();
  }
}